import { createTrackingUtils } from "../index";
import { UIBrandedFareFeature } from "@flights/types";

const utils = createTrackingUtils({
  name: "flights_apex_web_bf_modal_additional_inclusions",
  stages: {
    main: 1, // users who see the modal with at least 1 additional inclusion
    ddot: 2,
    mdot: 3,
    very_high_confidence: 4,
    high_confidence: 5,
    medium_confidence: 6,
    multiple_highlighted: 7,
    has_sellable_feature: 8
  },
  goals: {
    proceeds_with_upsell: 1,
    closes_modal: 2
  },
  goalsWithValue: [],
  defaultStage: 1
});

const trackStages = (
  isMobile: boolean,
  confidenceLevel: string | undefined,
  uniqueUpsellFeatures: UIBrandedFareFeature[],
  hasSellableFeature: boolean
) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (confidenceLevel === "MEDIUM") utils.stages.medium_confidence();
  if (confidenceLevel === "HIGH") utils.stages.high_confidence();
  if (confidenceLevel === "VERY_HIGH") utils.stages.very_high_confidence();
  if (uniqueUpsellFeatures.length > 1) utils.stages.multiple_highlighted();
  if (hasSellableFeature) utils.stages.has_sellable_feature();
};

export default { trackStages, ...utils };
